export default "__VITE_ASSET__55e15ff1__"